import { GlobalModalAction, GlobalModalState } from "./modals.global.types";

export const globalModalSetAction = (modal: Partial<GlobalModalState>): GlobalModalAction => ({ type: 'GLOBAL_MODAL_SET', params: modal })

export const globalModalCloseAction = (): GlobalModalAction => ({ type: 'GLOBAL_MODAL_CLOSE' })

export const globalModalOpenAction = (): GlobalModalAction => ({ type: 'GLOBAL_MODAL_OPEN' })